import React from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { useTranslation } from "react-i18next"

export interface ProductType {
  id: string
  name: string
  category: string
  couponBased: boolean
  price: string
  size: string
  stock: number
  featured: boolean
  status: "Active" | "In Active"
}

interface ProductActionMenuProps {
  product: ProductType
  viewDetailsHandler: (product: ProductType) => void
  editProductHandler: (product: ProductType) => void
  deleteProductHandler: (product: ProductType) => void
  addNewOffer: (product: ProductType) => void
  addNewCampaign: (product: ProductType) => void
  duplicateProductHandler: (product: ProductType) => void
}

export const ProductActionMenu: React.FC<ProductActionMenuProps> = ({
  product,
  viewDetailsHandler,
  editProductHandler,
  deleteProductHandler,
  addNewOffer,
  addNewCampaign,
  duplicateProductHandler,
}) => {
  const { t } = useTranslation()

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-vertical font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem onClick={() => viewDetailsHandler(product)}>
          <span className="">{t("common_viewDetails")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => editProductHandler(product)}>
          <span className="">{t("common_edit")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => addNewOffer(product)}>
          <span className="">{t("common_addOffer")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => addNewCampaign(product)}>
          <span className="">{t("common_addCompaign")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => duplicateProductHandler(product)}>
          <span className="">{t("products_duplicateProduct")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => deleteProductHandler(product)}>
          <span className="text-danger">{t("products_deleteProduct")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
